import { createTheme } from '@mui/material/styles';

// Saheeh brand tokens — see PROJECT_DOCUMENTATION.md §9.
export const palette = {
  primary:        '#00C896',
  primaryDark:    '#00A37A',
  primaryHoverHi: '#1AD4A6',
  primaryHoverLo: '#00B387',
  gold:           '#D4AF37',
  bg:             '#0A2540',
  bgElev:         '#143052',
  bgPanel:        'rgba(10, 37, 64, 0.7)',
  text:           '#ffffff',
  textMuted:      'rgba(255,255,255,0.7)',
  textFaint:      'rgba(255,255,255,0.5)',
  border:         'rgba(0, 200, 150, 0.15)',
  borderHover:    'rgba(0, 200, 150, 0.4)',
};

export const saheehTheme = createTheme({
  palette: {
    mode: 'dark',
    primary:   { main: palette.primary, dark: palette.primaryDark, light: palette.primaryHoverHi, contrastText: palette.bg },
    secondary: { main: palette.gold },
    background: { default: palette.bg, paper: palette.bgPanel },
    text: { primary: palette.text, secondary: palette.textMuted },
  },
  typography: {
    fontFamily: '"Inter", "Inter Tight", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    h1: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 999, fontWeight: 600 } } },
    MuiCard:   { styleOverrides: { root: { borderRadius: 16, backgroundColor: palette.bgPanel, backdropFilter: 'blur(20px) saturate(160%)', border: `1px solid ${palette.border}` } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: 'transparent', boxShadow: 'none' } } },
    MuiPaper:  { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});
